import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { IonicModule, LoadingController } from '@ionic/angular';
import { ToastController } from '@ionic/angular';
import { Analysis, BeerProfileRequest, BeerStat, SearchCharacteristicWithType, SearchType, AnalysisItem, LocalCharacteristic, Venue, SimilarBeerRequest, BaseFlavors} from "../../models/models";
import { AnalysisServiceProvider } from '../../providers/analysis-service/analysis-service';
import { LocationServiceProvider } from "../../providers/location-service/location-service";
import { UserDataProvider } from '../../providers/user-data/user-data';
import { BeerServiceProvider } from '../../providers/beer-service/beer-service';
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { AnalysisHolderProvider } from '../../providers/analysis-holder/analysis-holder';
import { RefdataProvider } from '../../providers/refdata/refdata';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage-angular';
import { AppEventService } from '../../app/app-events';
import { SimilarBeersComponent } from '../similar-beers/similar-beers';
import { BeerSpiderComponent } from '../beer-spider/beer-spider';
import { BeerCcComponent } from '../beer-cc/beer-cc';
import { FlavorSliderAnalysisComponent } from '../flavor-slider/flavor-slider-analysis';
import { BeerHiveComponent } from '../beer-hive/beer-hive';
import { BeerIbaComponent } from '../beer-iba/beer-iba';
import { BeerAromasComponent } from '../beer-aromas/beer-aromas';
import { RatingBarComponent } from '../rating-bar/rating-bar';
import { WishlistButtonComponent } from '../wishlist-button/wishlist-button';
import { CommonModule } from '@angular/common';
import { MyNotesComponent } from '../my-notes/my-notes';
import { FormsModule } from '@angular/forms';
import { BeerAnalysisMyComponent } from './beer-analysis-my';

/**
 * Generated class for the BeerAnalysisMyComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'beer-analysis-my-mouthfeel',
  templateUrl: 'beer-analysis-my-mouthfeel.html',
  styleUrls: ['./beer-analysis-my.scss'],
  standalone: false,
  imports: [
    IonicModule,
    TranslateModule,
    SimilarBeersComponent,
    BeerSpiderComponent,
    BeerCcComponent,
    FlavorSliderAnalysisComponent,
    BeerHiveComponent,
    BeerIbaComponent,
    BeerAromasComponent,
    RatingBarComponent,
    WishlistButtonComponent,
    CommonModule,
    FormsModule,
    MyNotesComponent
  ]
})

export class BeerAnalysisMyMouthfeelComponent extends BeerAnalysisMyComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

  analysisCharacteristics: Array<SearchCharacteristicWithType>;  // Array of typed key/value pairs
  characteristicsKeyNames: Array<string> = undefined;  // only keys, for passing to <beer-aromas> as input

  /*
   *  the model: beerID and analysis objects
   */
  theBeerID: string;

  /*
   *  other local attributes
   */
  // contains nbr of analyses per group (currently always 1 for group "brewer" and >=1 for group "beerhive")
  @Input()
  set beerID(bID: string) {
    this.theBeerID = bID;
    this.updateBeerID(bID);
  }
  get beerID() {
    return this.theBeerID;
  }

  private postAnalysisSubscription: any;
  private showBeerSubscription: any;

  constructor(
    protected toastController: ToastController,
    protected events: AppEventService,
    protected analysisService: AnalysisServiceProvider,
    private locationService: LocationServiceProvider,
    private userData: UserDataProvider,
    private beerService: BeerServiceProvider,
    protected bhutil: BhutilProvider,
    private loadingCtrl: LoadingController,
    protected beerAnalysisHolder: AnalysisHolderProvider,
    private refdata: RefdataProvider,
    protected translateService: TranslateService,
    private storage: Storage
  ) {
    super(toastController, events, analysisService, bhutil, beerAnalysisHolder, translateService);

    this.showBeerSubscription = () => {
      console.log("[beer-analysis-my.showBeerSubscription] called");
      // needed???
      this.clearTransferObjectsAndModel();

      // 2 Fill the model
      // 2A if the beer profile is not yet loaded, load the beer profile
      // 2B if the beer profile is already loaded, switch the analysisHolder to the beer
      if (this.beerAnalysisHolder.hasActiveBeer()) {
        this.updateBeerID(this.beerAnalysisHolder.getActiveBeer());

        if (this.beerAnalysisHolder.hasBeer(this.theBeerID)) {
          console.log("Beeranalysiscomponent.showBeerSubscription: switch to beer " + this.theBeerID);
          this.beerAnalysisHolder.switchToBeer(this.theBeerID);

          // 3 Update the GUI elements, fill the transfer objects and publish the updates to the GUI
          this.updateView();
        }
        else {
          console.log("BeeranalysisMyComponent.showBeerSubscription: no beer profile");
        }
      }
      else {
          console.log("BeeranalysisMyComponent.showBeerSubscription: no active beer");
      }
    };

    this.postAnalysisSubscription = (characteristics: Array<SearchCharacteristicWithType>) => {
      console.log("[beer-analysis-my-mouthful] SUB post:analysis");
      console.dir(characteristics);

      // update transfer objects
      this.analysisCharacteristics = characteristics;

      // update keyNames and prepare key/value pairs and mouthfeel
      let tempCharacteristicsKeyNames = [];
      let tempCharacteristicsKeyValuePairs = [];
      let intensity: number | undefined = undefined;
      let body: number | undefined = undefined;
      let astringent: number | undefined = undefined;
      let alcohol: number | undefined = undefined;
      let carbonation: number | undefined = undefined;
      for (let aChar of characteristics) {
        let charIndex = aChar.characteristic.key.indexOf("_");//used to be aChar.indexOf()???
        if (charIndex != -1) {
          // there is an _ in the item name => aroma, ...
          // check for value (do not add if value == 0) => this means the item still has to be removed
          if (aChar.characteristic.value.valueOf() > 0) {
            // fix for bug BEERHIVE-95 ???
            console.log("postAnalysisSubscription: ADDing " + aChar.characteristic.key);
            tempCharacteristicsKeyNames.push(aChar.characteristic.key);
            tempCharacteristicsKeyValuePairs.push({ name: aChar.characteristic.key, value: aChar.characteristic.value});
          }
          else {
            // not adding this item
            console.log("postAnalysisSubscription: NOT adding " + aChar.characteristic.key);
          }
        }
        else {
          switch (aChar.characteristic.key) {
            case "intensity": intensity = aChar.characteristic.value.valueOf(); break;
            case "body": body = aChar.characteristic.value.valueOf(); break;
            case "astringent": astringent = aChar.characteristic.value.valueOf(); break;
            case "alcohol": alcohol = aChar.characteristic.value.valueOf(); break;
            case "carbonation": carbonation = aChar.characteristic.value.valueOf(); break;
            default: break;
          }
        }
      }
      console.log("[beer-analysis-my.postAnalysisSubscription] - characteristics are: " + characteristics.join(","));
      this.characteristicsKeyNames = tempCharacteristicsKeyNames;

      // update the model
      // - binary aromas
      // - intensity, body, astringent, alcohol, carbonation
      //
      // the model has 2 parts:
      // - characteristics: the 8 main binary aromas
      // - characteristicsvalues: array of name/value pairs
      let myAnalysis = this.beerAnalysisHolder.getMyAnalysis();
      if (!myAnalysis || myAnalysis == null) {
        console.log("postAnalysisSubscription: NO myAnalysis present");
        throw new Error("postAnalysisSubscription: NO myAnalysis present");
      }
      this.beerAnalysisHolder.getMyAnalysis().characteristics = tempCharacteristicsKeyNames;
      this.beerAnalysisHolder.getMyAnalysis().characteristicsvalues = tempCharacteristicsKeyValuePairs;
      if (intensity) this.beerAnalysisHolder.getMyAnalysis().intensity = intensity;
      if (body) this.beerAnalysisHolder.getMyAnalysis().body = body;
      if (astringent) this.beerAnalysisHolder.getMyAnalysis().astringent = astringent;
      if (alcohol) this.beerAnalysisHolder.getMyAnalysis().alcohol = alcohol;
      if (carbonation) this.beerAnalysisHolder.getMyAnalysis().carbonation = carbonation;
      this.beerAnalysisHolder.checkForDifferences();
    };
    this.analysisCharacteristics = [];
  }
  private clearTransferObjectsAndModel() {
    // 1 Make the context clean:
    //   - empty the model: deactivate the previous beer profile from the analysis holder
    //   - empty the transfer objects and the view
    // 2 Fill the model
    // 2A if the beer profile is not yet loaded, load the beer profile
    // 2B if the beer profile is already loaded, switch the analysisHolder to the beer
    //
    // 3 Fill the transfer objects and publish the updates to the GUI
    // 1 Make the context clean:

    //   - empty the transfer objects and the view
    //aromas
    this.clearAromasTransferObjectsandPublishEvent();

    // inform beer-hive component
    this.events.publish("clear:analysis", true);

    this.beerAnalysisHolder.shouldCheck = true;
  }

  ionViewWillEnter() {
    console.log("beer-analysis-my - ionViewWillEnter called");
    if (this.refdata.isAndroid()) {
      console.log('setting fixed position dynamically for android');
      let saveButtonEl: HTMLElement = document.getElementById('save');
      saveButtonEl.style.position = 'fixed';
      // critcontainerEl.style.zIndex = '100';
    }
  }

  ngAfterViewInit() {
    console.log("[beer-analysis-my-mouthful] ngAfterViewInit called");

    this.updateView();

    /*this.storage.get('selected-venue').then((venue) => {
      // First read the selected venue from storage
      let venueJSON = JSON.parse(venue);
      if (venueJSON != null) {
        this.selectedVenue = venueJSON;
        console.log("[my-analyses] - currently venue with id selected: " + venueJSON.id);
      }
    });*/
  }

  // show current analysis instance
  showCurrentAnalysis(shouldShowToast: boolean) {
    console.log("[beer-analysis-my.showCurrentAnalysis] called with shouldShowToast = " + shouldShowToast);

    let currentAnalysis: Analysis = this.beerAnalysisHolder.getMyAnalysis();
    // this.tweakAnalysisBeforeViewing(currentAnalysis);

    // Step 1: populate transfer objects

    // Step 1A - currentBaseFlavors
    // Step 1B - analysisCharacteristics and characteristicsKeyNames
    this.updateCharacteristicsFromAnalysis(currentAnalysis);
    this.updateMouthfeelFromAnalysis(currentAnalysis);

    let currentAnalysisId = currentAnalysis.id;
    if (currentAnalysisId != undefined)
      this.analysisService.setAnalysisId(currentAnalysisId);
  }

  updateBeerID(bID: string) {
    console.log("updateBeerID() => " + bID);
    //debugger;
    this.theBeerID = bID;
    this.analysisService.setBeerId(bID);
  }

  ngOnInit() {
    console.log("[beer-analysis-my-mouthful] [ngOnInit] called");
    // setting last caller page
    this.events.subscribe("beer-analysis:show:beer-analysis-my", this.showBeerSubscription);
    this.events.subscribe("post:analysis", this.postAnalysisSubscription);

    this.analysisService.setLastPage("analysis");
  }
  ngOnChanges() {
    console.log("[beer-analysis-my-mouthful] [ngOnChanges] called");
  }

  ngOnDestroy() {

    console.log("[beer-analysis-my-mouthful] [ngOnDestroy] DESTROYING for beer ID " + this.theBeerID);
    this.events.unsubscribe("beer-analysis:show:beer-analysis-my");
    this.events.unsubscribe("post:analysis", this.postAnalysisSubscription);
    this.events.unsubscribe("similar-beers:show:beer-analysis", this.showBeerSubscription);
  }

  public updateView() {
    console.log("[beer-analysis-my-mouthful] updateView() called");
    this.showCurrentAnalysis(false);
  }

  updateMouthfeelFromAnalysis(currentAnalysis) {
    //debugger;
    console.log("[beer-analysis-my-mouthful]updateMouthfeelFromAnalysis()=> " + this.bhutil.stringify(currentAnalysis));

    let alcohol = -1;
    let astringent = -1;
    let carbonation = -1;
    let intensity = -1;
    let body = -1;
    if (currentAnalysis.alcohol !== undefined)
      alcohol = currentAnalysis.alcohol;
    if (currentAnalysis.astringent !== undefined)
      astringent = currentAnalysis.astringent;
    if (currentAnalysis.body !== undefined)
      body = currentAnalysis.body;
    if (currentAnalysis.carbonation !== undefined)
      carbonation = currentAnalysis.carbonation;
    if (currentAnalysis.intensity !== undefined)
      intensity = currentAnalysis.intensity;

    let source = 2;

    //create an event
    let mouthfeelEvent = {};
    mouthfeelEvent["alcohol"] = alcohol;
    mouthfeelEvent["astringent"] = astringent;
    mouthfeelEvent["body"] = body;
    mouthfeelEvent["carbonation"] = carbonation;
    mouthfeelEvent["intensity"] = intensity;
    mouthfeelEvent["source"] = source;

    //publish the event
    console.log("[beer-analysis-my-mouthful] PUB update:mouthfeel 2");
    this.events.publish("update:mouthfeel", mouthfeelEvent);
    //catch the event in the beer-hive item (or add it to the update:aromas as an extra field)

  }

  updateCharacteristicsFromAnalysis(currentAnalysis) {
    let characteristics = [];
    //debugger;//setting char
    if (currentAnalysis && currentAnalysis.characteristicsvalues) {
      for (let aChar of currentAnalysis.characteristicsvalues) {
        let charIndex = aChar.name.indexOf("_");//used to be aChar.indexOf()???
        if (charIndex != -1) {
          // there is an _ in the item name => aroma, ...
          // check for value (do not add if value == 0) => this means the item still has to be removed
          if (aChar.value > 0) {
            // fix for bug BEERHIVE-95 ???
            console.log("updateCharacteristicsFromAnalysis: ADDing " + aChar.name);
            characteristics.push(aChar.name);
          }
          else {
            // not adding this item
            console.log("updateCharacteristicsFromAnalysis: NOT adding " + aChar.name);
          }
        }
        else {
          characteristics.push(aChar.name);
        }
      }
      console.log("[beer-analysis.updateCharacteristicsFromAnalysis] - characteristics are: " + characteristics.join(","));
      this.characteristicsKeyNames = characteristics;
    }
    else {
    }
    //debugger;
    console.log("[beer-analysis-my-mouthful] updateCharacteristicsFromAnalysis => PUB set:characteristics => " + currentAnalysis);
    //debugger;//pubchar2
    this.events.publish("set:characteristics", characteristics);

    //TODO TEST TEST TEST
    this.events.publish("set:shouldUpdate", true);
  }

  clearAromasTransferObjectsandPublishEvent() {
    console.log("[beer-analysis-my-mouthful] clearAromas()");

    // fix for BEERHIVE-197
    // we needed to add this line, explicitly setting the aromas to an empty list!
//    this.events.publish("update:aromas", []);
    this.characteristicsKeyNames = [];

    //create an event
    let mouthfeelEvent = {};
    mouthfeelEvent["alcohol"] = -1;
    mouthfeelEvent["astringent"] = -1;
    mouthfeelEvent["body"] = -1;
    mouthfeelEvent["carbonation"] = -1;
    mouthfeelEvent["intensity"] = -1;
    mouthfeelEvent["source"] = 3;

    //publish the event
    console.log("[beer-analysis-my-mouthful] PUB update:mouthfeel 3");
    this.events.publish("update:mouthfeel", mouthfeelEvent);

  }
}
